import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import EbroucherService from "./EbrouchersService";


export const getEbrouchers = createAsyncThunk("Ebroucher/get-Ebrouchers", async (thunkAPI) => {
  try {
    return await EbroucherService.getEbrouchers();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createEbrouchers = createAsyncThunk(
  "Ebroucher/create-Ebrouchers",
  async (EbroucherData, thunkAPI) => {
    try {
      return await EbroucherService.createEbrouchers(EbroucherData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getEbroucher = createAsyncThunk(
  "Ebroucher/get-Ebroucher",
  async (id, thunkAPI) => {
    try {
      return await EbroucherService.getEbroucher(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateEbroucher = createAsyncThunk(
  "Ebroucher/update-Ebroucher",
  async (brand, thunkAPI) => {
    try {
      return await EbroucherService.updateEbroucher(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAEbroucher = createAsyncThunk(
  "Ebroucher/delete-Ebroucher",
  async (id, thunkAPI) => {
    try {
      return await EbroucherService.deleteEbroucher(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Ebrouchers: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const EbroucherSlice = createSlice({
  name: "Ebroucher",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEbrouchers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEbrouchers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Ebrouchers = action.payload.data;
      })
      .addCase(getEbrouchers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createEbrouchers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createEbrouchers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdEbroucher = action.payload;
      })
      .addCase(createEbrouchers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getEbroucher.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEbroucher.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Ebrouchertype = action.payload.data.type;
        state.EbrouchershortName= action.payload.data.shortName;
        state.Ebroucheremail= action.payload.data.email;
        state.EbroucherName= action.payload.data.name;
        
       
        
        
        
      })
      .addCase(getEbroucher.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateEbroucher.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateEbroucher.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedEbroucher = action.payload;
      })
      .addCase(updateEbroucher.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAEbroucher.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAEbroucher.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedEbroucher = action.payload;
      })
      .addCase(deleteAEbroucher.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default EbroucherSlice.reducer;
